type RouteHandler = (
  request: Request,
  params: URLSearchParams,
  pathParams: Record<string, string>,
) => Promise<Response>;

interface Route {
  method: string;
  path: RegExp;
  handler: RouteHandler;
}

export default class ServiceWorkerRouter {
  private routes: Route[] = [];
  public host: string = '';
  public protocol: string = '';
  constructor(host: string = 'localhost:3000', protocol: string = 'http:') {
    this.host = host;
    this.protocol = protocol;
  }

  public registerRoute(method: string, path: string, handler: RouteHandler) {
    const pathRegex = new RegExp(path);
    this.routes.push({ method, path: pathRegex, handler });
  }

  public async handleFetchEvent(event: FetchEvent) {
    const url = new URL(event.request.url);
    const matchingRoute = this.routes.find(
      (route) => event.request.method === route.method && route.path.test(url.pathname),
    );
    const matchingHost = this.host === url.host;
    const matchProtocol = this.protocol === url.protocol;
    if (matchingRoute && matchingHost && matchProtocol) {
      try {
        const pathParams = this.extractPathParams(matchingRoute.path, url.pathname);
        event.respondWith(matchingRoute.handler(event.request, url.searchParams, pathParams));
        console.log(`%c[JSDC.SW] ${event.request.method} ${url.pathname}`, 'color: #00aaff');
      } catch (error) {
        console.log(
          `%c[JSDC.SW] ${event.request.method} ${url.pathname} ${error}`,
          'color: #ff0000',
          error,
        );
      }
    } else {
      event.respondWith(fetch(event.request));
    }
  }

  private extractPathParams(pattern: RegExp, path: string): Record<string, string> {
    const matches = pattern.exec(path);
    const params: Record<string, string> = {};
    // Assuming named capturing groups in RegExp pattern
    if (matches && matches.groups) {
      for (const [key, value] of Object.entries(matches.groups)) {
        params[key] = value;
      }
    }
    return params;
  }
}
